/*
 * AUTO-GENERATED, DO NOT EDIT
 */
export const gray = {
    '50': {
        title: 'Gray 50',
        hex: '#f2f3f5',
    },
    '100': {
        title: 'Gray 100',
        hex: '#e6e8ec',
    },
    '200': {
        title: 'Gray 200',
        hex: '#ced2d9',
    },
    '300': {
        title: 'Gray 300',
        hex: '#b6bcc6',
    },
    '400': {
        title: 'Gray 400',
        hex: '#9ea6b3',
    },
    '500': {
        title: 'Gray 500',
        hex: '#8690a0',
    },
    '600': {
        title: 'Gray 600',
        hex: '#6e7683',
    },
    '700': {
        title: 'Gray 700',
        hex: '#565d67',
    },
    '800': {
        title: 'Gray 800',
        hex: '#3f434a',
    },
    '900': {
        title: 'Gray 900',
        hex: '#272a2e',
    },
    '950': {
        title: 'Gray 950',
        hex: '#1b1d20',
    },
};
export const blue = {
    '50': {
        title: 'Blue 50',
        hex: '#e8f1fe',
    },
    '100': {
        title: 'Blue 100',
        hex: '#d2e3fe',
    },
    '200': {
        title: 'Blue 200',
        hex: '#a6c8fd',
    },
    '300': {
        title: 'Blue 300',
        hex: '#7aacfd',
    },
    '400': {
        title: 'Blue 400',
        hex: '#4e91fc',
    },
    '500': {
        title: 'Blue 500',
        hex: '#2276fc',
    },
    '600': {
        title: 'Blue 600',
        hex: '#1e61cd',
    },
    '700': {
        title: 'Blue 700',
        hex: '#1a4d9e',
    },
    '800': {
        title: 'Blue 800',
        hex: '#17396f',
    },
    '900': {
        title: 'Blue 900',
        hex: '#132540',
    },
    '950': {
        title: 'Blue 950',
        hex: '#111b29',
    },
};
export const purple = {
    '50': {
        title: 'Purple 50',
        hex: '#f8e9fe',
    },
    '100': {
        title: 'Purple 100',
        hex: '#f2d3fe',
    },
    '200': {
        title: 'Purple 200',
        hex: '#e6a7fd',
    },
    '300': {
        title: 'Purple 300',
        hex: '#d97bfd',
    },
    '400': {
        title: 'Purple 400',
        hex: '#cd4efc',
    },
    '500': {
        title: 'Purple 500',
        hex: '#c123fc',
    },
    '600': {
        title: 'Purple 600',
        hex: '#9d1fcd',
    },
    '700': {
        title: 'Purple 700',
        hex: '#7a1b9e',
    },
    '800': {
        title: 'Purple 800',
        hex: '#56186f',
    },
    '900': {
        title: 'Purple 900',
        hex: '#331440',
    },
    '950': {
        title: 'Purple 950',
        hex: '#211229',
    },
};
export const magenta = {
    '50': {
        title: 'Magenta 50',
        hex: '#fcebf5',
    },
    '100': {
        title: 'Magenta 100',
        hex: '#f9d7eb',
    },
    '200': {
        title: 'Magenta 200',
        hex: '#f4afd8',
    },
    '300': {
        title: 'Magenta 300',
        hex: '#ef87c4',
    },
    '400': {
        title: 'Magenta 400',
        hex: '#ea5fb1',
    },
    '500': {
        title: 'Magenta 500',
        hex: '#e5389e',
    },
    '600': {
        title: 'Magenta 600',
        hex: '#ba3082',
    },
    '700': {
        title: 'Magenta 700',
        hex: '#8f2866',
    },
    '800': {
        title: 'Magenta 800',
        hex: '#65204a',
    },
    '900': {
        title: 'Magenta 900',
        hex: '#3a182d',
    },
    '950': {
        title: 'Magenta 950',
        hex: '#25141f',
    },
};
export const red = {
    '50': {
        title: 'Red 50',
        hex: '#fdebea',
    },
    '100': {
        title: 'Red 100',
        hex: '#fcd8d5',
    },
    '200': {
        title: 'Red 200',
        hex: '#f9b1ab',
    },
    '300': {
        title: 'Red 300',
        hex: '#f68b82',
    },
    '400': {
        title: 'Red 400',
        hex: '#f36458',
    },
    '500': {
        title: 'Red 500',
        hex: '#f03e2f',
    },
    '600': {
        title: 'Red 600',
        hex: '#c33529',
    },
    '700': {
        title: 'Red 700',
        hex: '#962c23',
    },
    '800': {
        title: 'Red 800',
        hex: '#69231d',
    },
    '900': {
        title: 'Red 900',
        hex: '#3c1a17',
    },
    '950': {
        title: 'Red 950',
        hex: '#261514',
    },
};
export const orange = {
    '50': {
        title: 'Orange 50',
        hex: '#fef0e6',
    },
    '100': {
        title: 'Orange 100',
        hex: '#fee2ce',
    },
    '200': {
        title: 'Orange 200',
        hex: '#fdc59d',
    },
    '300': {
        title: 'Orange 300',
        hex: '#fca86d',
    },
    '400': {
        title: 'Orange 400',
        hex: '#fb8b3c',
    },
    '500': {
        title: 'Orange 500',
        hex: '#e57322',
    },
    '600': {
        title: 'Orange 600',
        hex: '#ba5f1f',
    },
    '700': {
        title: 'Orange 700',
        hex: '#904b1b',
    },
    '800': {
        title: 'Orange 800',
        hex: '#653818',
    },
    '900': {
        title: 'Orange 900',
        hex: '#3a2415',
    },
    '950': {
        title: 'Orange 950',
        hex: '#251a13',
    },
};
export const yellow = {
    '50': {
        title: 'Yellow 50',
        hex: '#fef7da',
    },
    '100': {
        title: 'Yellow 100',
        hex: '#fdefb6',
    },
    '200': {
        title: 'Yellow 200',
        hex: '#fcdf6d',
    },
    '300': {
        title: 'Yellow 300',
        hex: '#fbd024',
    },
    '400': {
        title: 'Yellow 400',
        hex: '#d9b421',
    },
    '500': {
        title: 'Yellow 500',
        hex: '#b7991e',
    },
    '600': {
        title: 'Yellow 600',
        hex: '#967e1c',
    },
    '700': {
        title: 'Yellow 700',
        hex: '#746219',
    },
    '800': {
        title: 'Yellow 800',
        hex: '#534717',
    },
    '900': {
        title: 'Yellow 900',
        hex: '#312c14',
    },
    '950': {
        title: 'Yellow 950',
        hex: '#201e13',
    },
};
export const green = {
    '50': {
        title: 'Green 50',
        hex: '#e7f9ed',
    },
    '100': {
        title: 'Green 100',
        hex: '#d0f4dc',
    },
    '200': {
        title: 'Green 200',
        hex: '#a1eaba',
    },
    '300': {
        title: 'Green 300',
        hex: '#72e097',
    },
    '400': {
        title: 'Green 400',
        hex: '#43d675',
    },
    '500': {
        title: 'Green 500',
        hex: '#3ab564',
    },
    '600': {
        title: 'Green 600',
        hex: '#329454',
    },
    '700': {
        title: 'Green 700',
        hex: '#297343',
    },
    '800': {
        title: 'Green 800',
        hex: '#215233',
    },
    '900': {
        title: 'Green 900',
        hex: '#183122',
    },
    '950': {
        title: 'Green 950',
        hex: '#14211a',
    },
};
export const cyan = {
    '50': {
        title: 'Cyan 50',
        hex: '#e3fafd',
    },
    '100': {
        title: 'Cyan 100',
        hex: '#c7f5fc',
    },
    '200': {
        title: 'Cyan 200',
        hex: '#90ecf9',
    },
    '300': {
        title: 'Cyan 300',
        hex: '#59e3f6',
    },
    '400': {
        title: 'Cyan 400',
        hex: '#22daf4',
    },
    '500': {
        title: 'Cyan 500',
        hex: '#1fb8ce',
    },
    '600': {
        title: 'Cyan 600',
        hex: '#1c97a8',
    },
    '700': {
        title: 'Cyan 700',
        hex: '#197583',
    },
    '800': {
        title: 'Cyan 800',
        hex: '#16545d',
    },
    '900': {
        title: 'Cyan 900',
        hex: '#133237',
    },
    '950': {
        title: 'Cyan 950',
        hex: '#112124',
    },
};
//# sourceMappingURL=hues.js.map